import React from 'react'
import CreatableSelect from 'react-select/creatable'
import personsoccupationslistte from '../Person/Personoccupationlistte'
import personsoccupationslist from '../Person/personsoccupationslist'
import './checkbox.css'

export default function Personinputmodel(editarr, changevalue) {
  const occupations =
    editarr[0] === 'occupation_En' ? personsoccupationslist() : personsoccupationslistte()
  const occupationsselecton = (
    <div>
      <CreatableSelect
        options={occupations}
        isMulti
        value={editarr[1]}
        isSearchable
        onChange={event => changevalue(event)}
      />
    </div>
  )
  const genrefields2 = [...editarr[3]]
  const genrevalue = genrefields2.map((e, i) => (
    <div key={`person${i}`} className='restrictionage1'>
      <div key={`person${i}`} className='checkbox-list'>
        <input
          type='checkbox'
          name={`person${e.value}`}
          id={`person${i}`}
          checked={e.selected}
          onChange={event => changevalue(event, e.value, i)}
        />
        <label htmlFor={`person${i}`}>{e.value}</label>
      </div>
    </div>
  ))
  if (editarr[0] === 'about_En') {
    return (
      <div className='textAreaDiv'>
        <textarea
          className='testAreaTag'
          value={editarr[1]}
          onChange={event => changevalue(event)}
        />
      </div>
    )
  }

  if (editarr[0] === 'about_Te') {
    return (
      <div className='textAreaDiv'>
        <textarea
          className='testAreaTag'
          value={editarr[1]}
          onChange={event => changevalue(event)}
        />
      </div>
    )
  }

  if (editarr[0] === 'dateOfBirth') {
    return <input value={editarr[1]} type='date' onChange={event => changevalue(event)} />
  }

  if (editarr[0] === 'currentlyActive') {
    return editarr[2]
  }

  if (editarr[0] === 'genres_En') {
    return (
      <div
        className={`custom-form-control button-style horizontal ${
          genrevalue.length >= 2 ? 'first-last' : 'no-list'
        }`}
      >
        {genrevalue}
      </div>
    )
  }

  if (editarr[0] === 'genres_Te') {
    return (
      <div
        className={`custom-form-control button-style horizontal ${
          genrevalue.length >= 2 ? 'first-last' : 'no-list'
        }`}
      >
        {genrevalue}
      </div>
    )
  }

  if (editarr[0] === 'occupation_En') {
    return occupationsselecton
  }

  if (editarr[0] === 'occupation_Te') {
    return occupationsselecton
  }

  return (
    <input value={editarr[1]} className='inputTagEdit' onChange={event => changevalue(event)} />
  )
}
